import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {LOCKABLE_ENTITY_TYPE_LINKVIEW} from "./lockable-entity-type.constant";

/**
 * The payload the backend reads: `{ entityType, uid, expectedHolderUid }`.
 */
export interface OverrideEntityLockPayload {
    readonly entityType: string;
    readonly uid: string;

    /**
     * THE COMPARE-AND-SET. The holder the client saw when it rendered its
     * warning, sent back in the TRANSPORT spelling it was read in — never
     * converted, never upper-cased, never replaced by the acting user's own uid.
     * The server normalises it on arrival; sending any other form makes every
     * take-over fail, and it fails closed, so it reads as a permissions problem
     * rather than as a formatting bug.
     *
     * `null` is a legitimate value, not a missing one: it means "the client
     * believed the entity was FREE". That is the same compare with null as the
     * expected value — it succeeds if the entity really is free, and is refused
     * if somebody acquired it in the race window.
     */
    readonly expectedHolderUid: string | null;
}

/**
 * Takes the edit lock over from somebody else, after the user has been warned
 * and the current holder named.
 *
 * Take-over — not a timer — is the ONLY recovery from an abandoned lock, so
 * without this command a Linkboard whose holder walked away is permanently
 * uneditable.
 */
export class OverrideEntityLockCommand extends AbstractCommand<OverrideEntityLockPayload> {

    public name = CommandName.OVERRIDE_ENTITY_LOCK;

    public tags: string[] = [`entity`, `lock`, LOCKABLE_ENTITY_TYPE_LINKVIEW];

    constructor(payload: OverrideEntityLockPayload) {
        super(payload.entityType, payload.uid, payload);
    }
}
